<script lang="ts">
  import dayjs from 'dayjs';
  import { Button, ListItem } from 'svelte-materialify';
  import { push } from 'svelte-spa-router';
  import { getNextDate } from '../../lib/date';
  import { ReportService } from '../../modules';
  import type { ProjectConfig } from '../../modules/projects/project.interface';
  import type { Report } from '../../modules/report/report.interface';

  export let latestReport: Report;
  export let projectConfig: ProjectConfig;

  let reportDate = getNextDate(latestReport?.date);

  async function createReport() {
    const { date } = await ReportService.create(projectConfig.key, reportDate);
    push(`/report/${projectConfig.key}/${date}`);
  }
</script>

<div class="mb-6">
  <ListItem>
    <label class="date-picker">
      <input type="date" bind:value={reportDate} />
      <span class="date-formatted">{dayjs(reportDate).format('DD MMM')}</span>
    </label>
    <span slot="append">
      <Button class="amber" on:click={() => createReport()}>Prepare</Button>
    </span>
  </ListItem>
</div>

<style lang="scss">
  .date-picker {
    position: relative;
    overflow: hidden;
    padding-left: 40px;

    input[type='date'] {
      position: absolute;
      left: -140px;

      &:active,
      &:focus {
        outline: none;
      }
    }
  }
</style>
